export function getHeader(appId) {
    return {
        headers: {
            'App-Id': appId
        }
    };
}

/**
 * 将ClassAcl.vue文件传过来的数据，转成{role:dev: {read: true, write: true}}形式
 * @param accessInfo
 * @returns {Promise<unknown>}
 */
export async function packageACLInfo(accessInfo) {
    return new Promise((resolve, reject) => {
        let defaultACLInfo = {};
        let permissionNameList = Object.keys(accessInfo);
        for (let i = 0; i < permissionNameList.length; i++) {
            let permissionName = permissionNameList[i];
            let permissionInfo = accessInfo[permissionName];

            let isAllowAll = permissionInfo['allowAll'];
            let dataCreator = permissionInfo['dataCreator'];
            if (isAllowAll && isAllowAll === true) {
                let value = defaultACLInfo['*'];
                if (!value) {
                    value = {};
                }
                if (permissionName === 'write') {
                    value.write = true;
                } else {
                    value.read = true;
                }
                defaultACLInfo['*'] = value;
            } else if (dataCreator && dataCreator === true) {
                let value = defaultACLInfo['_dataCreator'];
                if (!value) {
                    value = {};
                }
                if (permissionName === 'write') {
                    value.write = true;
                } else {
                    value.read = true;
                }
                defaultACLInfo['_dataCreator'] = value;
            } else {
                // 用户
                let userAndRoleList = permissionInfo.userAndRoleList;
                userAndRoleList.forEach((t, index) => {
                    let key = '';
                    if (t.type === 'user') {
                        key = `${t.key}`;
                    } else {
                        key = `role:${t.key}`;
                    }
                    let value = defaultACLInfo[key];
                    if (!value) {
                        value = {};
                    }
                    if (permissionName === 'write') {
                        value.write = true;
                    } else {
                        value.read = true;
                    }
                    defaultACLInfo[key] = value;
                });
            }
            if (i === permissionNameList.length - 1) {
                resolve(defaultACLInfo);
            }
        }
    });
}

/**
 * 组装ACL组件参数，用于ClassAcl.vue文件
 * @param defaultACP
 * @returns {Promise<unknown>}
 */
export async function packageACLParam(defaultACP) {
    return new Promise((resolve, reject) => {
        let defaultACPInfo = {
            read: {
                requiresAuthentication: undefined,
                allowAll: undefined,
                roleAuthenticationMap: [],
                userAuthenticationMap: []
            },
            write: {
                requiresAuthentication: undefined,
                allowAll: undefined,
                roleAuthenticationMap: [],
                userAuthenticationMap: []
            }
        };
        if (Object.keys(defaultACP).length === 0) {
            delete defaultACPInfo.read.allowAll;
            delete defaultACPInfo.write.allowAll;
            resolve(defaultACPInfo);
            return;
        }
        let permissionNameList = Object.keys(defaultACP);
        for (let i = 0; i < permissionNameList.length; i++) {
            let key = permissionNameList[i];

            let acp = defaultACP[key];
            if (acp['read'] && acp['read'] === true) {
                if (key === '*') {
                    defaultACPInfo.read.allowAll = true;
                } else if (key === '_dataCreator') {
                    defaultACPInfo.read.dataCreator = true;
                } else {
                    let data = {};
                    data[`${key}`] = true;
                    if (key.startsWith('role:')) {
                        defaultACPInfo.read.roleAuthenticationMap.push(data);
                    } else {
                        defaultACPInfo.read.userAuthenticationMap.push(data);
                    }
                }
            }

            if (acp['write'] && acp['write'] === true) {
                if (key === '*') {
                    defaultACPInfo.write.allowAll = true;
                } else if (key === '_dataCreator') {
                    defaultACPInfo.write.dataCreator = true;
                } else {
                    let data = {};
                    data[`${key}`] = true;
                    if (key.startsWith('role:')) {
                        defaultACPInfo.write.roleAuthenticationMap.push(data);
                    } else {
                        defaultACPInfo.write.userAuthenticationMap.push(data);
                    }
                }
            }

            if (i === permissionNameList.length - 1) {
                resolve(defaultACPInfo);
            }
        }
    });
}
